import {ErrorDisplayProps, withErrorSubscribe} from './withErrorSubscribe'
import React from 'react'
import {
    ErrorProps,
    ResidentHocInputErrorHandling
} from '../resident/ResidentHocInputErrorHandling'

export type ErrorHandlingFormProps =
    ErrorDisplayProps &
    ErrorProps


export const createErrorHandlingForm = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & ErrorHandlingFormProps>,
) =>
    withErrorSubscribe(
        ResidentHocInputErrorHandling(WrappedComponent
        )
    )
